<template>
  <div class="choose">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2>Ideš do toho s nami?</h2>
        </div>
        <div class="col-md-6">
          <ChooseItem :id="'choose-item-1'" :route="{name: 'Quiz'}" :photo-url="'/static/img/choose-img-1.png'" :btn-text="'Chcem sa otestovať!'" :btnClass="'bg--pink'"></ChooseItem>
        </div>
        <div class="col-md-6">
          <ChooseItem v-on:choose="choose" :id="'choose-item-2'" :route="false" :photo-url="'/static/img/choose-img-2.png'" :btn-text="'Viem presne, kto som.'" :btnClass="'bg--green'"></ChooseItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseItem from './ChooseItem.vue'

export default {
  name: 'Choose',
  components: {
    ChooseItem
  },
  methods: {
    choose: function (e) {
      this.$emit('choose', e)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .choose {
    padding: 70px 0;
    text-align: center;
    h2 {
      color: $color-blue-text;
      font-size: 30px;
      font-weight: 700;
      line-height: 1;
    }
    @media (max-width: $breakpoint-sm) {
      padding: 50px 0;
      h2 {
        font-size: 24px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Choose.vue